import React from 'react';
import { useDispatch } from 'react-redux';
import '../../../test/App.scss';
import { TAnswerTest, TInteractiveTest } from '../../../store/interactive/types';
import { TRoom } from '../../../store/sockets/types';
import { ChekDoneTest, SendTest } from '../../../store/interactive/actions';
import { Circle } from '../../../test/components/Circle';
import { Button } from '../../../test/components/ui';
import { Success } from '../../../test/screens/Sucess';

interface TestProps {
  test: TInteractiveTest;
  room: TRoom;
  doneTest: { done: 0 | 1; points: number } | null;
  disabled: boolean;
}

export const Test: React.FC<TestProps> = React.memo(({ test, room, disabled, doneTest }) => {
  const [value, setValue] = React.useState<TAnswerTest[]>([] as TAnswerTest[]);
  const [currentQuestion, setCurrentQuestion] = React.useState(0);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (room && test.isFinish === 2) {
      dispatch(
        ChekDoneTest.request({
          data: {
            testId: test.id,
            event_id: room.event_id,
            roomId: room.absnum,
          },
        })
      );
    }
  }, [dispatch, room, test]);

  React.useEffect(() => {
    setValue([]);
    setCurrentQuestion(0);
  }, [doneTest, setValue, setCurrentQuestion]);

  const changeValue = (answerId: number, questionId: number) => {
    const answer = { questionId: questionId, answerId: answerId };
    const answers = value.filter((item) => item.questionId !== questionId);
    setValue([...answers, answer]);
  };

  const checkValue = (id: number) => {
    const answer = value.find((item) => item.answerId === id);
    return !!answer;
  };

  const sendValue = () => {
    dispatch(
      SendTest.request({
        data: {
          data: value,
          testId: test.id,
          event_id: room.event_id,
          roomId: room.absnum,
        },
      })
    );
  };

  const answerHandler = () => {
    if (currentQuestion < test.questions.length - 1) {
      setCurrentQuestion((prevState) => prevState + 1);
    } else {
      sendValue();
    }
  };

  if (doneTest === null || !test.questions[currentQuestion]) {
    return null;
  }

  if (test.isFinish === 3 || test.isFinish === 1) {
    return (
      <div style={{ color: 'green', margin: '20px', textAlign: 'center' }}>
        <span>{test.isFinish === 1 ? 'Тест не розпочато' : 'Тест завершено'}</span>
      </div>
    );
  }

  if (doneTest?.done === 1) {
    return (
      <Success>
        <h2>
          Вітаю! Ви закінчили.
          <br />
          Сумарно набрали балів {doneTest?.points || 0}
        </h2>
      </Success>
    );
  }

  return (
    <div style={{ padding: '20px 50px' }}>
      <div style={{ width: '100%' }}>
        <div className="tda__wrapper" style={{ width: '100%' }}>
          <div className="tda__circleTextWrapper">
            <Circle num={+((currentQuestion / test.questions.length) * 100).toFixed()} currentQuestion={currentQuestion} />
            <span>із {test.questions.length} запитань</span>
          </div>
          <div className="tda__testQWrapper" style={{ width: '100%' }}>
            <h5>{`Тема. ${test.title}`}</h5>
            <span style={{ fontSize: '18px' }}>{`${currentQuestion + 1}. ${test.questions[currentQuestion].name}`}</span>
            <ul>
              {test.questions[currentQuestion].answers.map((answer) => (
                <li
                  className={checkValue(answer.id) ? 'tda__active-itm' : ''}
                  key={answer.id}
                  onClick={() => changeValue(answer.id, test.questions[currentQuestion].id)}
                >
                  {answer.name}
                </li>
              ))}
            </ul>
            <div style={{ textAlign: 'center' }}>
              <Button disabled={disabled} onClick={answerHandler} title="Відповісти" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
